module.exports = __webpack_public_path__ + "img/1020.30dec9b5.png";